

import React from 'react';
import moment from 'moment';
import { Spin } from 'antd';

const BlogListingsSection = (props) => {
  const [appUrl] = window.location.href.split('/blogs');
  
  const { loading, data, history } = props;
  let firstBlogRow = data && data.length ? data.filter((value, index) => index <= 2) : []
  let secondBlogRow = data && data.length ? data.filter((value, index) => index > 2) : []
  return (
    <div>
      <Spin spinning={loading}>
        <section style={{ paddingBottom: '5px' }} className="trending-causes second-trending">
          <div className="container">
            <h2 className="main-heading  ">Recently Updated</h2>
            <div className="row justify-content-center">
              {
                firstBlogRow.map(({ id, title, text1: description, created_at: publishedOn, blog_photos: blogPhotos }, index) => {
                  let cover = '/images/Trending-img-1.png';
                  if (blogPhotos && blogPhotos.length) {
                    const [blogPhoto] = blogPhotos;
                    if (blogPhoto && blogPhoto.name) {
                      cover = `${process.env.REACT_APP_BACKEND_BASE_URL}/images/${blogPhoto.name}`;
                    }
                  }
                  const formattedDescription = description ? (description.length >= 90 ? `${description.substring(0, 90)}...` : description) : 'N/A';
                  const formattedTitle = title ? (title.length >= 22 ? `${title.substring(0, 22)}...` : title) : 'N/A';
                  return (
                    <div key={index} className="col-lg-4 col-md-4 col-sm-6 col-12">
                      <div style={{ cursor: 'pointer' }} onClick={() => history.push(`/blog-details/${id}`)} className="card">
                        <img src={cover} className="img-fluid" alt="" />
                        <div className="text-card d-flex align-items-center justify-content-between">
                          <span><img src="/images/team_2.png" className="img-fluid img-width" alt="" /></span>
                          <span>Published on: {publishedOn ? moment(publishedOn).format('DD MMM YYYY') : 'N/A'}</span>
                        </div>
                        <h1>{formattedTitle || 'N/A'}</h1>
                        <p>{formattedDescription}</p> <i className="fa fa-arrow-right"></i>
                      </div>
                      <div className="progres after-border">
                        <ul className="d-flex justify-content-center">
                          <li
                            onClick={() => {
                              const pageUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + appUrl + '/blog-details/' + id + '/j';
                              window.open(pageUrl, '_blank');
                            }
                            }>
                            <a href='#!' title=""><i className="fa fa-facebook"></i></a>
                          </li>
                          <li
                            onClick={() => {
                              //http://www.twitter.com/share?url=http://www.google.com/
                              const pageUrl = 'http://www.twitter.com/share?url=' + appUrl + '/blog-details/' + id;
                              window.open(pageUrl, '_blank');
                            }}>
                            <a href='#!' title=""><i className="fa fa-twitter"></i></a>
                          </li>
                          <li onClick={() => {
                            const pageUrl = 'https://www.linkedin.com/sharing/share-offsite/?url=' + appUrl + '/blog-details/' + id;
                            window.open(pageUrl, '_blank');
                          }}>
                            <a href='#!' title=""><i className="fa fa-linkedin"></i></a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  );
                })
              }
            </div>
          </div>
        </section>
        {
          (!loading) &&
          <section className="">
            <div className="container">
              <div className="row">
                <div className="col-lg-7 mx-auto text-left bg-primary text-white ">
                  <div className="text-home px-4 py-4">
                    <p className="mb-0">It is a long established fact that a reader
                      <br></br> will be distracted by the readable content
                      <br></br> of a page when looking at its layout.</p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        }
        <section style={{ paddingTop: '10px' }} className="trending-causes second-trending">
          <div className="container">
            <div className="row justify-content-center">
              {
                secondBlogRow.map(({ id, title, text1: description, created_at: publishedOn, blog_photos: blogPhotos }, index) => {
                  let cover = '/images/Trending-img-1.png';
                  if (blogPhotos && blogPhotos.length) {
                    const [blogPhoto] = blogPhotos;
                    if (blogPhoto && blogPhoto.name) {
                      cover = `${process.env.REACT_APP_BACKEND_BASE_URL}/images/${blogPhoto.name}`;
                    }
                  }
                  const formattedDescription = description ? (description.length >= 90 ? `${description.substring(0, 90)}...` : description) : 'N/A';
                  const formattedTitle = title ? (title.length >= 22 ? `${title.substring(0, 22)}...` : title) : 'N/A';
                  return (
                    <div key={index} className="col-lg-4 col-md-4 col-sm-6 col-12">
                      <div style={{ cursor: 'pointer' }} onClick={() => history.push(`/blog-details/${id}`)} className="card">
                        <img src={cover} className="img-fluid" alt="" />
                        <div className="text-card d-flex align-items-center justify-content-between">
                          <span><img src="/images/team_2.png" className="img-fluid img-width" alt="" /></span>
                          <span>Published on: {publishedOn ? moment(publishedOn).format('DD MMM YYYY') : 'N/A'}</span>
                        </div>
                        <h1>{formattedTitle || 'N/A'}</h1>
                        <p>{formattedDescription}</p> <i className="fa fa-arrow-right"></i>
                      </div>
                      <div className="progres after-border">
                        <ul className="d-flex justify-content-center">
                          <li
                            onClick={() => {
                              const pageUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + appUrl + '/blog-details/' + id + '/j';
                              window.open(pageUrl, '_blank');
                            }
                            }>
                            <a href='#!' title=""><i className="fa fa-facebook"></i></a>
                          </li>
                          <li
                            onClick={() => {
                              //http://www.twitter.com/share?url=http://www.google.com/
                              const pageUrl = 'http://www.twitter.com/share?url=' + appUrl + '/blog-details/' + id + '/j';
                              window.open(pageUrl, '_blank');
                            }}>
                            <a href='#!' title=""><i className="fa fa-twitter"></i></a>
                          </li>
                          <li onClick={() => {
                            const pageUrl = 'https://www.linkedin.com/sharing/share-offsite/?url=' + appUrl + '/blog-details/' + id;
                            window.open(pageUrl, '_blank');
                          }}>
                            <a href='#!' title=""><i className="fa fa-linkedin"></i></a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  );
                })
              }
            </div>
          </div>
        </section>
      </Spin>
    </div>
  );
}

export default BlogListingsSection;
